import { render, staticRenderFns } from "./LoremText.vue?vue&type=template&id=58fc4030&scoped=true&"
import script from "./LoremText.vue?vue&type=script&lang=js&"
export * from "./LoremText.vue?vue&type=script&lang=js&"
import style0 from "./LoremText.vue?vue&type=style&index=0&id=58fc4030&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc4030",
  null
  
)

export default component.exports